import { render, staticRenderFns } from "./Battle.vue?vue&type=template&id=4346fdea&scoped=true&lang=pug&"
import script from "./Battle.vue?vue&type=script&lang=js&"
export * from "./Battle.vue?vue&type=script&lang=js&"
import style0 from "./Battle.vue?vue&type=style&index=0&id=4346fdea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4346fdea",
  null
  
)

export default component.exports